import React from 'react'

import { Modal, Table, Button } from '_zari/core'

const HistorialComprasModal = ({ handleClose, show, idProductoPresentacion }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>HISTORIAL COMPRAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table.ServerSide
          url={`/api/productos/${idProductoPresentacion}`}
          baseParams={{
            variante: 'historial-compras'
          }}
          headRows={[
            { label: 'FECHA', width: 115 },
            { label: 'PROVEEDOR' },
            { label: 'NRO. FACT.', width: 115 },
            { label: 'COSTO' },
            { label: 'CANTIDAD' }
          ]}
          rowTemplate={row => (
            <Table.Row hover key={row._id}>
              <Table.Cell>{row.fechaEmision}</Table.Cell>
              <Table.Cell>{row.nombreProveedor}</Table.Cell>
              <Table.Cell>{`${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
              <Table.Cell>{parseFloat(row.precio).toFixed(2)}</Table.Cell>
              <Table.Cell>{`${row.cantidad} - ${row.unidadMedida}`}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(HistorialComprasModal)
